import React from "react";
import { ReactComponent as Visa } from "./Visa.svg";
import { ReactComponent as Mastercard } from "./Mastercard.svg";
import { Box } from "@mui/material";

const MastercardIcon = () => {
    const editedIcon = React.cloneElement(<Mastercard />, {
        style: {
            maxHeight: "16px",
            width: "auto",
            maxWidth: "120px",
        },
    });
    return <>{editedIcon}</>;
};

const VisaIcon = () => {
    const editedIcon = React.cloneElement(<Visa />, {
        style: {
            maxHeight: "13px",
            width: "auto",
            maxWidth: "120px",
            marginRight: "10px",
        },
    });
    return <>{editedIcon}</>;
};

export default function PaymentLogos() {
    return (
        <Box sx={{ display: "flex", alignItems: "center", alignContent: "center" }}>
            <VisaIcon />
            <MastercardIcon />
        </Box>
    );
}
